/**
 * TODO: Factorize with CAPEX Intelligence ? Almost the same 😕
 */

import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import * as R from 'ramda';

import { KPI } from './api';
import {
  DataType, FilterType, PerimeterFilter, PerimeterFilterRangeValue, PerimeterFilterValue, PerimeterPredicate,
} from './perimeter-filter';

/**
 * Defines a perimeter filter displayed in the `PerimetersFiltersDialogComponent`.
 */
export class PerimeterClusterFilter extends PerimeterFilter {
  constructor(
    label: string,
    clusters: KPI.Cluster[]
  ) {
    super();

    this.id = 'cluster';
    this.label = label;
    this.filtering = FilterType.FILTER_VALUE;
    this.dataType = DataType.DATA_TYPE_FK;
    this.availableValues = clusters.map((cluster) => {
      return {
        id: cluster.id,
        label: cluster.name,
      };
    });
  }

  public getPredicate(values: PerimeterFilterValue[] | PerimeterFilterRangeValue): PerimeterPredicate {
    return (perimeter: KPI.Perimeter) => {
      const filterValues = <PerimeterFilterValue[]>values;
      return R.includes(perimeter.cluster, filterValues.map(Number));
    };
  }
}
